// extracted by mini-css-extract-plugin
export var fullGrid = "_3i-3";
export var pdpPreviewContainer = "_3i-1";
export var previewContainer = "_3i-0";
export var togglePreviewContainer = "_3i-2";